import { PenLine, Sparkles, CalendarCheck } from "lucide-react";

const steps = [
  {
    icon: PenLine,
    number: "01",
    title: "Escribes tu duda",
    description:
      "Cuéntanos qué le pasa a tu mascota o qué necesitas. Puedes escribir como si hablaras con un amigo.",
  },
  {
    icon: Sparkles,
    number: "02",
    title: "El asistente te orienta",
    description:
      "Recibes respuestas claras, recomendaciones y, si detecta urgencia, te indica cómo actuar.",
  },
  {
    icon: CalendarCheck,
    number: "03",
    title: "Registramos tu solicitud de cita",
    description:
      "Si quieres, el asistente recoge tus datos y disponibilidad y deja una solicitud preparada para que el equipo la confirme.",
    note: "La confirmación final la realiza el centro. Integración con agenda/calendario: opcional.",
  },
];

export const HowItWorksSection = () => {
  return (
    <section
      id="como-funciona"
      data-testid="how-it-works-section"
      className="py-20 md:py-28"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-14 md:mb-20">
          <span className="text-sm font-medium tracking-wide uppercase text-primary/80 mb-3 block">
            Proceso
          </span>
          <h2
            data-testid="how-it-works-title"
            className="text-3xl md:text-4xl font-bold text-foreground tracking-tight mb-4"
          >
            Así de fácil funciona
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-lg mx-auto">
            En tres sencillos pasos, tendrás la orientación que necesitas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 relative">
          {/* Connecting line (desktop only) */}
          <div className="hidden md:block absolute top-[72px] left-[16.67%] right-[16.67%] h-px bg-border" />

          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div
                key={index}
                data-testid={`step-card-${index}`}
                className="relative text-center"
              >
                {/* Step number circle */}
                <div className="relative z-10 w-[88px] h-[88px] mx-auto mb-6 rounded-full bg-white border-2 border-primary/15 flex items-center justify-center shadow-sm">
                  <div className="w-16 h-16 rounded-full bg-secondary flex items-center justify-center">
                    <Icon className="w-7 h-7 text-primary" strokeWidth={1.5} />
                  </div>
                </div>

                <span className="text-xs font-bold text-primary/50 tracking-widest uppercase mb-2 block">
                  Paso {step.number}
                </span>
                <h3 className="text-xl font-semibold text-foreground mb-3 tracking-tight">
                  {step.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed max-w-xs mx-auto">
                  {step.description}
                </p>
                {step.note && (
                  <p className="text-xs text-muted-foreground/70 mt-2 max-w-xs mx-auto">
                    {step.note}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
